/** @jsxImportSource @emotion/react */
import { FromLink } from "../../../../utils/useNavigateFrom";
import Field, { DataSource } from "./Field";

class LayerLocationLink extends Field {
    field_type = "layer_location_link";

    backend_table = "latest_location";

    is_filterable(): boolean {
        return true;
    }

    // * set the value from one of the the objects
    set_value(datasource: DataSource): this {
        let value = "-";
        if (datasource.layer?.latest_location?.location_id) {
            value = datasource.layer.latest_location.location_id;
        }
        this.value = this.value_filter(value, datasource);
        this.config = datasource.config;
        return this;
    }

    display_component(): JSX.Element {
        if (this.value === "-") {
            return <span>-</span>;
        }

        return (
            <FromLink to={`/ripening-room/${this.value}`}>
                {this.get_form_option_label(this.value)}
            </FromLink>
        );
    }
}

export default LayerLocationLink;
